import Icon from '@/components/ui/AppIcon';

interface Highlight {
  icon: string;
  title: string;
  description: string;
}

interface ProgramOverviewProps {
  highlights: Highlight[];
  description: string;
}

export default function ProgramOverview({ highlights, description }: ProgramOverviewProps) {
  return (
    <section className="py-16 bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-headline font-bold text-foreground mb-4">
            Program Overview
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-3xl mx-auto">
            {description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((highlight, index) => (
            <div
              key={index}
              className="p-6 bg-surface rounded-xl border border-border hover:border-primary hover:shadow-sky-sm transition-all duration-300"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <Icon name={highlight.icon as any} size={24} variant="outline" className="text-primary" />
              </div>
              <h3 className="text-lg font-headline font-semibold text-foreground mb-2">
                {highlight.title}
              </h3>
              <p className="text-sm text-muted-foreground font-body">
                {highlight.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}